import ClaimBasicDetails from "./ClaimBasicDetails";
import TabComponent from "../../../../utilsComponent/TabComponent";
import ClaimIntimationDetail from "../Intimation/ClaimIntimationDetails";
import InvestigationPage from "../Investigation/InvestigationPage"
import MedicalReviewPage from "../MedicalReview/MedicalReviewPage";
import { useLocation, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { getHospitalClaimDetails, searchClaimProcessing } from "../Service/apiHelper";
import { functionalities, PAGE_NAME_KEYS } from "../../../../consts";
import ClaimHistory from "../../ClaimIntimation/PolicyInfo/ClaimHistory";
import { viewModeOn } from "../../../../utilFunctions";
import LoadingPage from "../../../../reusableComponents/loader/loadingPage";
import ClaimAudit from "../../../claimAudit"
import { getFromDecreaptLocalStorage } from "../../../../utilFunctions";
import { toast } from "react-toastify";
import ClaimCalculations from "../Calculation/ClaimCalculations";
import HealthDocuments from "../Documents/HealthDocuments";
import { getBasicSearchResults } from "../../ClaimIntimation/Search/apiHelper";
import ClaimPayout from "../Payout/ClaimPayout";

const HealthClaimDetails = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [claimBasicDetails, setClaimBasicDetails] = useState(location.state?.claimDetails);
  const [healthClaimDetails, setHealthClaimDetails] = useState([]);
  const [activeTab, setActiveTab] = useState(null)
  const [loading, setLoading] = useState(false);
  const roleDataCookie = getFromDecreaptLocalStorage("roleData")

  const [policyDetails,setPolicyDetails]=useState(null)
  const getPolicyDetails = async () => {
          // setLoading(true);
          const searchFields = {
            search_type: { value: "1" }, // we are keeping value 1 because we are searching with product name
            product_name: { label: claimBasicDetails?.productName },
            search_type_value: claimBasicDetails?.policyId,
          };
          try {
            const response = await getBasicSearchResults(searchFields, setLoading);
            if (response?.data && response.data !== "No Data Present") {
              setPolicyDetails(response?.data[0]);
            } else {
              setPolicyDetails(null);
            }
          } catch (error) {
            console.error("Failed to fetch data:", error);
            setPolicyDetails(null);
          }
        };

  const getClaimDetails = async(claimId) => {
    await getHospitalClaimDetails(claimId || claimBasicDetails?.claimId, setHealthClaimDetails)
  }
  useEffect(() => {
     getPolicyDetails()
     getClaimDetails()
  }, [claimBasicDetails?.claimId])


  useEffect(() => {
    if (location.state?.activeTab) {
      setActiveTab(location.state.activeTab);
      handleClaimChange(claimBasicDetails?.claimId, false)
    } else {
      const tabsToView = TABS.filter(tab => tab.show)
      if (tabsToView.length) {
        setActiveTab(tabsToView[0].key)
      }
    }
  }, [location.state]);


  const TABS = [
    {
      key: "CLAIM_INTIMATION",
      title: "Claim Intimation",
      child: <ClaimIntimationDetail claimDetails={healthClaimDetails} claimId={claimBasicDetails?.claimId} claimBasicDetails={claimBasicDetails} getClaimDetails={getClaimDetails} />,
      show: viewModeOn(functionalities.INTIMATION_SUMMARY_TAB)
    },
    {
      key: "INVESTIGATION",
      title: "Investigation",
      child: <InvestigationPage roleDataCookie= {roleDataCookie} claimDetails={claimBasicDetails} activeTab={activeTab} />,
      show: viewModeOn(functionalities.INVESTIGATION_TAB) && claimBasicDetails?.subStatus && !["intimation", "rejected","rejection review"].includes(claimBasicDetails?.subStatus?.toLowerCase())
    },
    {
      key: "MEDICAL REVIEW",
      title: "Medical Review",
      child: <MedicalReviewPage roleDataCookie= {roleDataCookie} claimStatus={claimBasicDetails?.subStatus} claimDetails={claimBasicDetails} activeTab={activeTab}/>,
       show: viewModeOn(functionalities.MEDICAL_REVIEW_TAB) && claimBasicDetails?.subStatus && !["intimation", "rejected","rejection review"].includes(claimBasicDetails?.subStatus?.toLowerCase())
    },
     {
      key: "Calculation",
      title: "Claim Calculation",
      child: <ClaimCalculations claimDetailCookie={healthClaimDetails} claimId={claimBasicDetails?.claimId} claimBasicDetails={claimBasicDetails} getClaimDetails={getClaimDetails} roleDataCookie={roleDataCookie} policyDetailCookie={policyDetails} />,
      show: viewModeOn(functionalities.CALCULATION_SUMMARY_TAB) &&  !["open","in-progress"].includes(claimBasicDetails?.investigationStatus?.toLowerCase()) && !["open","in-progress"].includes(claimBasicDetails?.medicalReviewStatus?.toLowerCase()) && claimBasicDetails?.subStatus && !["intimation", "rejected","rejection review"].includes(claimBasicDetails?.subStatus?.toLowerCase())
    },
     {
      key: "Payout",
      title: "Claim Payout",
      child: <ClaimPayout claimDetailCookie={healthClaimDetails} claimId={claimBasicDetails?.claimId} claimBasicDetails={claimBasicDetails} getClaimDetails={getClaimDetails} roleDataCookie={roleDataCookie} policyDetailCookie={policyDetails} />,
      show: viewModeOn(functionalities.PAYOUT_SUMMARY_TAB) && claimBasicDetails?.subStatus && !["intimation", "rejected","rejection review"].includes(claimBasicDetails?.subStatus?.toLowerCase()) && claimBasicDetails?.netPayout > 0
    },
  ];

  

  const handleClaimChange = (claimId, isNavigate = true) => {
    setLoading(true)
    searchClaimProcessing(
      { claimId },
      { size: 10, page: 0 },
      (list) => {
        if (list.length) {
          if (isNavigate) {
            navigate(
              `/dashboard/${PAGE_NAME_KEYS.HEALTH_CLAIM_PROCESSING}/${PAGE_NAME_KEYS.CLAIM_DETAILS}`, {
              state: {
                claimDetails: list[0]
              }
            }
            );
          } 
          setClaimBasicDetails(list[0])
          
        } else {
          toast.error("Something Went Wrong.")
        }
      }
    );
    setLoading(false)

  }


  return (
    <>
      <ClaimBasicDetails claimDetails={claimBasicDetails} claimId={claimBasicDetails?.claimId} />
      <TabComponent tabArray={TABS.filter(tab => tab.show)} activeKey={activeTab} onTabSelect={(k) => {
        navigate('.', {
          state: {
            ...location.state,
            activeTab: k,
          },
          replace: true,
        });
      }} />
      {activeTab === PAGE_NAME_KEYS.CLAIM_HISTORY && (
        <ClaimHistory
          setLoading={setLoading}
          policyId={claimBasicDetails?.policyId}
          showLink
          handleClick={(claimDetails) => handleClaimChange(claimDetails.claimId)}
        />
      )}
      {activeTab === PAGE_NAME_KEYS.AUDIT_TRAIL && (
        <ClaimAudit claimId={claimBasicDetails?.claimId} />
      )}
      {activeTab === PAGE_NAME_KEYS.DOCUMENTS && (
        <HealthDocuments claimDetails={claimBasicDetails} policyDetailCookie={policyDetails}/>
      )}
      {loading && (
        <LoadingPage kshemaLoader />
      )}
    </>
  );
};
export default HealthClaimDetails;
